export function formatAverageGrade(averageGrade: number): string {
  return averageGrade ? averageGrade.toFixed(1) : '0';
}

export function formatReviewsCount(reviewsCount: number): string {
  const reviewsCountStr = reviewsCount.toString();
  if (reviewsCount < 1000) {
    return reviewsCountStr;
  }
  const hundredsIndex = reviewsCountStr.length - 3;
  const hundreds = reviewsCountStr.substring(hundredsIndex);
  const thousands = reviewsCountStr.substring(0, hundredsIndex);
  return `${thousands} ${hundreds}`;
}

export function getThumbnailLogoUrl(logoUrl: string | null): string {
  if (!logoUrl) {
    return '';
  }
  if (!logoUrl.includes('/assets/')) {
    return logoUrl;
  }
  const [baseUrl, imageName] = logoUrl.split('/assets/');
  return `${baseUrl}/assets/thumbnail_320_240/${imageName}`;
}
